import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { TipoEquipamentoService } from 'src/app/services/tipo-equipamento.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Prioridade } from '../../domain/domain.model';
import { TipoDeEquipamento } from './../../domain/domain.model';



@Component({
  selector: 'app-tipoequipamento',
  templateUrl: './tipoequipamento.component.html',
  styleUrls: ['./tipoequipamento.component.scss']
})
export class TipoequipamentoComponent implements OnInit, AfterContentInit {

  public cadastrados: Prioridade[] = [];
  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  autorizacoes: UsuarioAutorizacoes = null;

  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private tipoEquipamentoService: TipoEquipamentoService,
    private formBuilder: FormBuilder

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('tipo-equipamento');
  }

  ngOnInit() {
    this.getAll();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  private getAll() {
    this.isLoading = true;
    this.tipoEquipamentoService.getAll().subscribe(response => {
      this.cadastrados = response;
      this.isLoading = false;
      this.setVoids();
    });
  }


  public resetForm(): void {
    this.form = this.formBuilder.group({
      id: [0],
      descricao: ['', [Validators.required, Validators.maxLength(30)]]
    })
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
  }

  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.tipoEquipamentoService.getById(id).subscribe(

      (response: TipoDeEquipamento) => {
        this.form.get('id').setValue(response.id);
        this.form.get('descricao').setValue(response.descricao);
        
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.form.get('id').value === 0) {
      this.tipoEquipamentoService.isUnique(this.form.get('descricao').value).subscribe(

        (isUniqueDescricao: boolean) => {

          if (isUniqueDescricao) {
            this.save();
          } else {
            this.form.get('descricao').setErrors({ isNotUniqueDescricao: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }

  }


  public save() {

    this.tipoEquipamentoService.post(this.form.value as TipoDeEquipamento).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.tipoEquipamentoService.delete(id).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    // this.form.get('codigo').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }


}
